<template>
  <button class="btn mb-0" :class="buttonClasses">
    <slot />
  </button>
</template>

<script>
export default {
  name: "MaterialButton",
  props: {
    color: {
      type: String,
      default: "primary", // ← تم تغيير اللون الافتراضي للأزرق
    },
    size: {
      type: String,
      default: "md",
    },
    variant: {
      type: String,
      default: "fill",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClasses() {
      const classes = [];

      // Variant and color
      if (this.variant === "gradient") {
        classes.push(`bg-gradient-${this.color}`);
      } else if (this.variant === "outline") {
        classes.push(`btn-outline-${this.color}`);
      } else {
        classes.push(`btn-${this.color}`);
      }

      // Size
      if (this.size) {
        classes.push(`btn-${this.size}`);
      }

      // Full width
      if (this.fullWidth) {
        classes.push(`w-100`);
      }

      // Active
      if (this.active) {
        classes.push(`active`);
      }

      return classes.join(" ");
    },
  },
};
</script>
